import styles from "./style.module.scss";

import DynamicForm from "@mavichpe/dynamic-forms";
import { ProductTaxChangeDataType } from "@/formTypes/ProductTaxChangeDataType";
import ChangeProductTaxFormConfig from "./form";

type ChangeProductTaxFormProps = {
  onTaxChanged: (data: ProductTaxChangeDataType) => void,
  defaultData: ProductTaxChangeDataType,
  innerForm?: boolean
}

const ChangeProductTaxForm = (props: ChangeProductTaxFormProps) => {
  const { onTaxChanged, innerForm = false, defaultData } = props;

  const onSubmit = (formData: ProductTaxChangeDataType) => {
    if (onTaxChanged) {
      onTaxChanged(formData)
    }
  }

  return (
    <>
      <DynamicForm<ProductTaxChangeDataType>
        externalFormState={defaultData}
        innerForm={innerForm}
        formConfig={ChangeProductTaxFormConfig}
        onSubmit={onSubmit}
      >
      </DynamicForm>
    </>

  )
}

export default ChangeProductTaxForm;